import { render, staticRenderFns } from "./ProductionTaskCard.vue?vue&type=template&id=53221cf2&scoped=true&"
import script from "./ProductionTaskCard.vue?vue&type=script&lang=ts&"
export * from "./ProductionTaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTaskCard.vue?vue&type=style&index=0&id=53221cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53221cf2",
  null
  
)

export default component.exports